import { render, staticRenderFns } from "./TranslationRow.vue?vue&type=template&id=6c1636dc&"
import script from "./TranslationRow.vue?vue&type=script&lang=js&"
export * from "./TranslationRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports